const IS_LOADING = "list/rolesScopes/IS_LOADING";
const IS_ERROR = "list/rolesScopes/IS_ERROR";
const DATA = "list/rolesScopes/DATA";
export { IS_LOADING, IS_ERROR, DATA };
